import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { QuotationComponent } from './quotation/quotation.component';
import { UserFormComponent } from './quotation/user-form/user-form.component';
import { UserDetailsComponent } from './quotation/user-details/user-details.component';
import { ProductFormComponent } from './quotation/product-form/product-form.component';
import { ProductDetailsComponent } from './quotation/product-details/product-details.component';

import { NavBarComponent } from '../app/quotation/nav-bar/nav-bar.component';

@NgModule({
  declarations: [
    AppComponent,
    QuotationComponent,
    UserFormComponent,
    UserDetailsComponent,
    ProductFormComponent,
    ProductDetailsComponent,
    NavBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
